import {Component, OnInit} from '@angular/core';
import {Apollo, gql} from "apollo-angular";
import {map, Observable, of} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "../../../services/notification.service";
import {GET_AUDIT_LOGS} from "./audit-trail.graphql";
import {getInstitutionUsers} from "../../../store/entities/instution-settings/instution-user/instution-user.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/reducers";
import {Institution} from "../../../store/entities/system-settings/institution/institution.model";
import {StorageService} from "../../../services/storage.service";
import {
  selectModifiedInstutionUsers
} from "../../../store/entities/instution-settings/instution-user/instution-user.selectors";
import {InstutionUser} from "../../../store/entities/instution-settings/instution-user/instution-user.model";
import {getSystemAdministrators} from "../../../store/entities/system-settings/user-management/user-management.actions";
import {
  UserTypeInum
} from "../../../store/entities/system-settings/institution/institution-admin/institution-admin.model";
import {
  selectSystemAdministrators
} from "../../../store/entities/system-settings/user-management/user-management.selectors";
import {UserManagement} from "../../../store/entities/system-settings/user-management/user-management.model";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrl: './audit-trail.component.scss'
})

export class AuditTrailComponent implements OnInit{

  auditLogs: Observable<{
    fullName?: string
    username?: string
    action?: string
    actionTime?: string
  }[]>

  tableColumns: any

  from: 'INSTITUTION' | 'POPSMGG'
  institution: Institution;
  institutionsUsers$:Observable<InstutionUser []>;
  users$: Observable<UserManagement[]>

  filtering: {
    endDate?: string;
    startDate?: string;
    logType?: string;
    username?: string;
  } = {
    endDate: null,
    startDate: null,
    logType: 'Activity',
    username: null,
  }

  constructor(
    private apollo: Apollo,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private storageService: StorageService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {

    this.from = this.route.snapshot.data['from']

    this.tableColumns = {
      no: 'SN',
      fullName:  'Full Name',
      username: 'Username',
      action: 'Action',
      actionTime: 'Action Time',
    };

    if (this.from === 'INSTITUTION') {

      this.institutionsUsers$ = this.store.select(selectModifiedInstutionUsers);
      this.institution = this.storageService.getItem('institution');
      this.store.dispatch(getInstitutionUsers({filtering:{institutionUniqueId:this.institution?.id}}));

    } else {
      this.store.dispatch(getSystemAdministrators({
        filtering: {
          profileType: UserTypeInum.POPSM
        }
      }))

      this.users$ = this.store.select(selectSystemAdministrators)
    }

    this.auditLogs = this.loadAuditLogs()
  }

  loadAuditLogs(filtering?: any): Observable<any> {
    return this.apollo.query({
      query: GET_AUDIT_LOGS,
      fetchPolicy: 'network-only',
      variables: {
        filtering: {
          startDate: filtering?.startDate,
          endDate: filtering?.endDate,
          logType: filtering?.logType,
          username: filtering?.username,
          institutionUniqueId: this.institution?.id,
        }
      },
    }).pipe(
      map(({ data }: any) => {
        const result: any = data?.getAuditLogs;
        if (result?.response?.status && result?.data) {
          return result?.data;
        } else {
          this.notificationService.errorMessage(
            result?.response?.message ?? 'Failed to load Audit Logs.'
          );
          return of([]);
        }
      })
    );
  }

  onFilterChange(): void {
    this.auditLogs = this.loadAuditLogs({
      endDate: this.filtering?.endDate,
      startDate: this.filtering?.startDate,
      logType: this.filtering?.logType,
      username: this.filtering?.username,
    });
  }
}
